import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsIssueNewAssetModalOpen = createStore(() => useState(false));
